const basicPaymentPlan = {
  id: '',
  active: true,
  installments: '',
  name: ''
};

export default basicPaymentPlan;
